// export const API_URL = process.env.REACT_APP_WEB_API_URL || ''
export const API_URL = import.meta.env.VITE_APP_WEB_API_URL || ''

export const API_LOGIN_ENDPOINTS = ['/api/auth/login', '/api/mobileid/start', '/api/smartid/start', '/auth/login']
